export default "__VITE_ASSET__c87eb16d__"